import {
  ADD_LOOKUP,
  EDIT_LOOKUP,
  DELETE_LOOKUP,
  FETCH_LOOKUP,
  DESTROY_LOOKUP
} from "../actionTypes";

export const addLookup = lookup => ({
  type: ADD_LOOKUP,
  lookup
});

export const fetchLookup = lookup => ({
  type: FETCH_LOOKUP,
  lookup
});

export const editLookup = lookup => ({
  type: EDIT_LOOKUP,
  lookup
});

export const deleteLookupByID = id => ({
  type: DELETE_LOOKUP,
  id
});

export const destroyLookup = key => ({
  type: DESTROY_LOOKUP,
  key
})